import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export const LaunchOffer = () => (
  <section className="bg-ink py-14 md:py-20">
    <div className="container">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="mx-auto max-w-4xl rounded-2xl border-2 border-gold bg-gradient-to-br from-navy via-ink to-navy p-6 text-center shadow-elevated md:p-10">
        <Sparkles className="mx-auto mb-4 h-10 w-10 text-gold" />
        <p className="text-xs font-semibold uppercase tracking-[0.4em] text-gold">Launch Offer</p>
        <h2 className="mt-3 font-display text-3xl tracking-wide text-white sm:text-4xl md:text-5xl">We're just getting started in Edmonton</h2>
         <p className="mx-auto mt-4 max-w-2xl text-base text-white/80 md:text-lg">Clients get <span className="font-bold text-gold">30% off</span> their first cleanout + priority same-week booking.</p>
        <div className="my-6 inline-flex max-w-full items-center gap-3 rounded-full border border-gold/40 bg-ink/60 px-4 py-2 sm:px-6">
          <span className="h-2 w-2 animate-pulse rounded-full bg-gold" />
          <span className="font-display text-lg tracking-wider text-gold sm:text-2xl">7 SPOTS REMAINING</span>
        </div>
        <div>
          <Button asChild size="lg" className="h-14 w-full max-w-xs bg-gold px-6 font-bold uppercase tracking-wider text-ink shadow-gold hover:bg-gold/90 sm:w-auto sm:px-10">
            <a href="https://api.whatsapp.com/send?phone=15874073024&text=Hi%20Garage%20Kings!%20%F0%9F%91%91%20I%27d%20like%20a%20quote%20for%20a%20cleanout.%20What%20photos%20or%20info%20do%20you%20need%20from%20me%20to%20get%20started%3F" target="_blank" rel="noopener noreferrer">
              Claim Your Spot
            </a>
          </Button>
        </div>
        <div className="mt-10">
          <p className="mb-4 text-xs uppercase tracking-widest text-white/40">Trusted by Edmonton homeowners</p>
          <div className="flex flex-wrap items-center justify-center gap-4 opacity-50">
            {["YEG LIVING", "EDMONTON HOMES", "CITY GUIDE", "LOCAL PRESS"].map((b) => (
              <div key={b} className="rounded border border-white/20 px-4 py-2 text-xs font-bold tracking-widest text-white/60">{b}</div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
